// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results.error-popup {
  width: 300px;
  padding: 12px;
  border-radius: 12px;
  text-align: left;
  align-items: stretch;
}

.error-popup-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 8px;
}

.error-popup-icon {
  font-size: 18px;
  line-height: 1;
  flex-shrink: 0;
}

.error-popup-title {
  color: var(--tg-theme-button-color);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.15;
}

.error-popup-text {
  width: 100%;
  color: var(--tg-theme-text-color);
  font-size: 15px;
  line-height: 1.35;
  white-space: pre-wrap;
  margin-bottom: 10px;
}

.error-popup-actions {
  width: 100%;
  display: flex;
  gap: 8px;
}

.error-popup-button {
  flex: 1 1;
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  font-size: 15px;
  border: none;
  padding: 10px 8px;
  border-radius: 10px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.error-popup-button.secondary {
  background-color: var(--tg-theme-hint-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/results/GameNotLoaded.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,8CAA8C;EAC9C,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;AAC9C","sourcesContent":[".results.error-popup {\n  width: 300px;\n  padding: 12px;\n  border-radius: 12px;\n  text-align: left;\n  align-items: stretch;\n}\n\n.error-popup-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-bottom: 8px;\n}\n\n.error-popup-icon {\n  font-size: 18px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.error-popup-title {\n  color: var(--tg-theme-button-color);\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.15;\n}\n\n.error-popup-text {\n  width: 100%;\n  color: var(--tg-theme-text-color);\n  font-size: 15px;\n  line-height: 1.35;\n  white-space: pre-wrap;\n  margin-bottom: 10px;\n}\n\n.error-popup-actions {\n  width: 100%;\n  display: flex;\n  gap: 8px;\n}\n\n.error-popup-button {\n  flex: 1;\n  background-color: var(--tg-theme-button-color);\n  color: var(--tg-theme-button-text-color);\n  font-size: 15px;\n  border: none;\n  padding: 10px 8px;\n  border-radius: 10px;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.error-popup-button.secondary {\n  background-color: var(--tg-theme-hint-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
